<template>
    <div :class="$style.root">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'PageBody',
    };
</script>

<style lang="less" module>
    @import "../styles/variables";

    .root {
        flex: 1;
        background-color: @page-body-bg-color;
        border-radius: 0 0 8px 8px;
        overflow: hidden;

        [class^="PageTitle"] + & {
            border-radius: 8px;
        }
    }
</style>
